import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import {
  DefaultTablePagination, InputBox
} from '../../components/_utils/appUtils'
import { ColumnWidth } from '../WebComponent/columnWidth'
import { Col, Icon, Row, Tooltip } from 'antd'
import {
  approveAdvanceCommissionFxn,
  getAllApprovedAdvanceCommissionsFxn
} from './actions'
import AgentTypeheadComponent from '../../components/_utils/AgentTypeheadComponent'

class ApprovedAdvanceCommissionList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      visibleDepositDrawer: false,
      agentId: ''
    }
    this.tableRef = React.createRef()
  }

  componentDidMount() {
    //use effect
  }

  events = {
    reload: () => {
      this.tableRef.current.reload()
    }
  }

  apiRequest = (params) => {
    let { dispatch } = this.props
    return new Promise(async (resolve) => {
      if (this.state.agentId) {
        params.agentId = this.state.agentId
      }
      let data = await dispatch(getAllApprovedAdvanceCommissionsFxn(params))
      console.log(data, 'data')
      resolve(data)
    })
  }

  searchFxn = async () => {
    this.events.reload()
  }

  clearFxn = async () => {
    this.setState({
      agentId: '',
      toDate: '',
      fromDate: ''
    })
    setTimeout(() => {
      this.events.reload()
    }, 200)
  }

  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => {
          return (
            <React.Fragment>
              {index + 1}
            </React.Fragment>
          )
        }
      },
      {
        title: 'Agent',
        key: 'user',
        dataIndex: 'user',
        width: 200,
        render: (item) => {
          return (
            <ColumnWidth width={200}>
              {item &&
              <>
                {item.name} ({item.companyName})
              </>
              }
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Total Commission',
        key: 'totalAmount',
        dataIndex: 'totalAmount',
        width: 80,
        render: (item) => {
          return (
            <ColumnWidth width={80}>
              £ {item} GBP
            </ColumnWidth>
          )
        }
      },
      {
        title: 'Current Balance',
        key: 'user',
        dataIndex: 'user',
        width: 100,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              {item && item.ukBalance && (
                <b>
                  £ {item.ukBalance} GBP<br />
                </b>
              )}
            </ColumnWidth>
          )
        }
      },
     /* {
        title: 'Actions',
        key: 'actions',
        dataIndex: 'actions',
        width: 100,
        render: (item) => {
          return (
            <ColumnWidth width={100}>
              <Tooltip title={'View'}>
                <a className={'btn btn-link'} target={'_blank'}>
                  <Icon type={'eye'} />
                </a> </Tooltip>
            </ColumnWidth>
          )
        }
      }*/
    ]
    return (
      <div>

        <div className='row  mt-4'>
          <div className='col-lg-12'>
            <div className='card'>
              <div className='table-head d-flex align-items-center'>
                <h5>Approved Advance Commission List</h5>
                <div className='search-box-table'>

                </div>
                <div className='sort-box-table mark-btn'>
                  <div>

                  </div>
                </div>

              </div>
              <div className='card-body table-responsive'>
                <Row className={'filter_box'} gutter={16}>
                  <Col md={6} sm={6} xs={8} lg={6}>
                    <InputBox title={'Search By Agent'} labelCls={'labelDoc'}>
                      <AgentTypeheadComponent
                        key={this.state.agentId}
                        agentId={this.state.agentId}
                        dispatch={this.props.dispatch}
                        customStyle={''}
                        onSelect={item => {
                          this.setState({
                            agentId: item
                          })
                        }}
                      />
                    </InputBox>
                  </Col>
                  <Col span={24}>
                    <div className={'btn_group'}>
                      <a className={'default_btn'} onClick={this.searchFxn}>Search</a>
                      <a className={'default_btn'} onClick={this.clearFxn}>Clear</a>
                    </div>
                  </Col>
                </Row>
                <TableComp columns={columns}
                           ref={this.tableRef}
                           pagination={DefaultTablePagination()}
                           apiRequest={this.apiRequest}
                           extraProps={{ scroll: { x: 1000 } }}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApprovedAdvanceCommissionList)
